<div [ngClass]="getLevelClass()">
  <basic-label [noIndent]="true"></basic-label>
  <div class="row">
    <div>
      <basic-text-input
        [propertyName]="questionItem.prop"
        [formatterType]="taxIdType"
        [placeholder]="taxIdType"
        [disableConditionally]="noTaxId"
        #taxIdInput
        (focusin)="showSSN()"
        (focusout)="obfuscateSSN()"
      ></basic-text-input>
    </div>
  </div>
  <div class="row">
    <ng-container *ngIf="use2019Filing && showCheckbox">
      <basic-checkbox
        id="noTaxIdFullProp"
        (change)="trigger()"
        [labelText]="checkboxText"
        [propertyName]="noTaxIdFullProp"
        #noTaxIdCheckbox
      ></basic-checkbox>
    </ng-container>

    <div *ngIf="!use2019Filing" class="checkbox">
      <!-- keeping below to support 2018 filing -->
      <input
        type="checkbox"
        id="noTaxId-{{ questionItem.prop }}"
        class="checkbox__input"
        value="noTaxId"
        [checked]="noTaxId ? 'checked' : null"
        [(ngModel)]="noTaxId"
        (change)="trigger()"
        [disabled]="isDisabled"
      />
      <div class="label-basic">
        <label
          *ngIf="questionItem.prop.indexOf('insured') > -1"
          class="checkbox__label label-basic__subtext"
          for="noTaxId-{{ questionItem.prop }}"
        >
          I don't have an SSN or TIN
        </label>
        <label
          *ngIf="questionItem.prop.indexOf('ownerPerson') > -1"
          class="checkbox__label label-basic__subtext"
          for="noTaxId-{{ questionItem.prop }}"
        >
          No SSN available
        </label>
      </div>
    </div>
  </div>
</div>
